
import { Item } from '@/types/Item';
import { PropType, defineComponent } from 'vue';

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
  },

  methods: {
    toggleItem() {
      this.$emit('toggleItem', this.item.id);
    },

    removeItem() {
      this.$emit('removeItem', this.item.id);
    },
  },

  emits: {
    toggleItem: (id: number) => Number.isInteger(id),
    removeItem: (id: number) => Number.isInteger(id),
  },
});
